<template>
  <b-card no-body class="card-map-ttc overflow-hidden h-100">
    <b-row no-gutters class="h-100">
      <b-col md="6">
        <b-card-body title="Corporativo JFS & TTC">
          <b-card-text>
            San Antonio #125 Col. Las fuentes
            <br>Zapopan Jal. México
            <br>Teléfonos: 01 (33) 38105608 / 38106536
          </b-card-text>
        </b-card-body>
      </b-col>
      <b-col md="6" class="d-flex justify-content-center">
       <div class="mapouter"><div class="gmap_canvas"><iframe width="100%" height="100%" id="gmap_canvas" src="https://maps.google.com/maps?q=San%20Antonio%20%23125%20Col.%20Las%20fuentes%20Zapopan%20Jal.%20Guadalajara%2C%20Jalisco%20M%C3%A9xico&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no"></iframe></div></div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'MapCardTTS'
}
</script>

<style>
.mapouter{
  margin-top:auto;
  position:relative;
  text-align:right;
  height:100%;
  width:100%;
}
.gmap_canvas {
  overflow:hidden;
  background:none!important;
  height:100%;
  width:100%;
}
</style>
